import gql from 'graphql-tag';

export const Claim = {
  fragment: gql`
    fragment Claim on Claim {
      id
      affiliate {
        id
        name
      }
      reason
      crmState
      passengerTicket {
        passengerFirstName
        passengerLastName
        passengerLanguage
        passengerEmail
        passengerPhone
      }
      flight {
        number
        airline {
          name
          iata
        }
        airlineCode
        localDepartureDate
        localArrivalDate
        airportOrigin {
          name
          iata
        }
        airportDestination {
          name
          iata
        }
      }
    }
  `
};



// WEBPACK FOOTER //
// ./src/fragments/claim.js